import axios from '@/plugins/axios';
import utils from '@/stores/utils';

const state = {
    establishment: null,
    establishment_loading: false,
    establishment_loading_errors: null,
    establishment_saving: false,
    establishment_saving_errors: null,
};

const mutations = {

    updateEstablishment(state, establishment) {
        state.establishment = establishment;
    },
    updateEstablishmentLoading(state, loading) {
        state.establishment_loading = loading;
    },
    updateEstablishmentLoadingErrors(state, errors) {
        state.establishment_loading_errors = errors;
    },
    updateEstablishmentSaving(state, saving) {
        state.establishment_saving = saving;
    },
    updateEstablishmentSavingErrors(state, errors) {
        state.establishment_saving_errors = errors;
    },
};

const actions = {

    async fetchEstablishment({ commit, dispatch, state }, params) {
        commit('updateEstablishmentLoading', true);
        commit('updateEstablishmentLoadingErrors', null);
        let url;
        if (params && params.establishment) {
            url = `/api/establishments/${params.establishment}/`;
        } else if (state.establishment) {
            url = `/api/establishments/${state.establishment.id}/`;
        } else {
            throw 'No establishment to fetch';
        }
        try {
            const response = await axios.get(url);
            commit('updateEstablishment', response.data);
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateEstablishmentLoadingErrors', error);
            throw error;
        } finally {
            commit('updateEstablishmentLoading', false);
        }
    },

    async saveEstablishment({ commit, dispatch, state }, params) {
        commit('updateEstablishmentSaving', true);
        commit('updateEstablishmentSavingErrors', {});

        let url = '/api/establishments/';
        let method = axios.post;

        if (params.instance.id) {
            url = `/api/establishments/${params.instance.id}/`;
            method = axios.put;
        }
        try {
            const response = await method(url, params.instance);
            commit('updateEstablishmentSaving', false);
            commit('updateEstablishmentSavingErrors', {});
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateEstablishmentSavingErrors', error.details);
            throw error;
        }
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};

